import { Box, Button, createStyles, LinearProgress, makeStyles, Theme } from '@material-ui/core';
import React, { useRef, useState } from 'react';
import { DEFAULT_CODEC_PREFERENCES, DEFAULT_EDGE } from '../constants';
import { Region } from './Tests/Tests.model';
import useTestRunner from './useTestRunner/useTestRunner';

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    progressWrapper: {
      width: '80%',
      margin: 'auto',
    },
    startButton: {
      padding: '12px 24px',
    },
  });
});

interface NetworkTestWidgetProps {
  getTURNCredentials: () => Promise<RTCIceServer[]>;
  getVoiceToken: () => Promise<string>;
  token?: string;
  region?: Region;
  iceServers?: RTCIceServer[];
  onComplete: (results: any) => void;
}

const initialSettings = {
  edge: DEFAULT_EDGE,
  codecPreferences: DEFAULT_CODEC_PREFERENCES,
};

export default function NetworkTestWidget({
  getTURNCredentials,
  getVoiceToken,
  onComplete,
  region,
}: NetworkTestWidgetProps) {
  const { isRunning, runTests } = useTestRunner();
  const [progress, setProgress] = useState(0);
  const classes = useStyles();
  const intervalObject = useRef<any>(null);

  const startProgressBar = () => {
    /* Progress bar defaulted to 40 seconds as the test if configured for preflight - 25 second and bitrate - 15 seconds. */
    intervalObject.current = setInterval(() => {
      setProgress((prevProgress) => {
        return prevProgress + 100 / 500;
      });
    }, 100);
  };

  async function startTest() {
    setProgress(0);
    onComplete(undefined);
    startProgressBar();
    const testResults = await runTests(
      getVoiceToken,
      getTURNCredentials,
      initialSettings.edge,
      initialSettings.codecPreferences,
      region
    );
    setProgress(100);
    if (intervalObject.current) {
      clearInterval(intervalObject.current);
    }
    onComplete(testResults);
  }

  // const isExpired = results?.errors?.bitrate?.message === 'expired' || results?.errors?.preflight?.message === 'expired';

  return (
    <div>
      <Box padding={2} display="flex" justifyContent={'center'}>
        <Button
          className={classes.startButton}
          onClick={startTest}
          variant="contained"
          color="secondary"
          disabled={isRunning}
          style={{ marginRight: '1em' }}
        >
          Start
        </Button>
      </Box>

      <Box padding={2} className={classes.progressWrapper}>
        {isRunning && <LinearProgress color={'secondary'} variant="determinate" value={progress} />}
      </Box>
    </div>
  );
}
